/**
 * @desc 海关要素-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.customsInfo.customsInfoExportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/customsInfo/customsInfoExportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
